import $ from "jquery";

let apiLoaded = false;
const players = {};

function loadAPIOnce() {
  if (apiLoaded || (window.YT && window.YT.Player)) return;
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  document.head.appendChild(tag);
  apiLoaded = true;
}

function ensurePlayers() {
  if (!window.YT || !window.YT.Player) return;
  $(".js-yt").each(function () {
    const id = this.id;
    if (!id || players[id]) return;
    players[id] = new YT.Player(id);
  });
}

export default function initYouTubeEmbeds() {
  loadAPIOnce();
  // Create players when API is ready
  window.onYouTubeIframeAPIReady = function () {
    ensurePlayers();
  };
  // Also try after DOM ready (in case API already present)
  if (window.YT && window.YT.Player) {
    ensurePlayers();
  }

  // Play on external button click
  $(document).on("click", ".js-yt-play", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const targetId = $btn.data("yt-target");
    const player = players[targetId];
    if (player && player.playVideo) {
      player.playVideo();
      $btn.hide();
      return;
    }
    const el = document.getElementById(targetId);
    if (el && el.tagName === "VIDEO") {
      try {
        el.play();
        $btn.hide();
      } catch (err) {
        // ignore
      }
    }
  });
}
